<template>
  <div class="withdrawal-details-ststus-wrapper" :class="[packageName]">
    <div class="custom-nav-block" :style="`padding-top:${barHeight}px;`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="goPrevious">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.png" alt="" />
        </template>
        <template #right>
          <div v-if="hasRefresh" class="refresh-wrapper" @click="handleGetData">
            <img src="@/assets/packageAssets/views/P1_Girls/WithdrawalDetails/vava/refresh.png" alt="refresh" width="20" height="20" :class="[isLoading ? 'refresh' : '']" />
          </div>
        </template>
      </van-nav-bar>
    </div>
    <!-- 内容 -->
    <div class="main">
      <template v-if="isLoading">
        <div class="loading-wrapper">
          <van-loading />
        </div>
      </template>
      <template v-else>
        <!-- 状态 -->
        <div class="status-wrapper">
          <!-- 状态图片 -->
          <template v-if="[0, 7, 8, 2, 5, 6].includes(info.state)">
            <img v-if="packageName === 'kiko'" src="@/assets/packageAssets/views/P1_Girls/WithdrawalDetails/vava/await.png" alt="icon" width="44" height="44" />
            <img v-else src="@/assets/packageAssets/views/P1_Girls/WithdrawalDetails/vava/await.png" alt="icon" width="44" height="44" />
          </template>
          <template v-else-if="[1, 4].includes(info.state)">
            <img src="@/assets/packageAssets/views/P1_Girls/WithdrawalDetails/vava/error.png" alt="icon" width="44" height="44" />
          </template>
          <template v-else-if="info.state === 3">
            <img v-if="packageName === 'kiko'" src="@/assets/packageAssets/views/P1_Girls/WithdrawalDetails/vava/finish-kiko.png" alt="icon" width="44" height="44" />
            <img v-else src="@/assets/packageAssets/views/P1_Girls/WithdrawalDetails/vava/finish.png" alt="icon" width="44" height="44" />
          </template>
          <template v-else></template>
          <!-- 状态文案 -->
          <p class="status-title">{{ statusTextMap[info.state] || '-' }}</p>
          <template v-if="info.remark">
            <p class="status-subtitle">{{ info.remark }}</p>
          </template>
          <template v-else>
            <!-- 提示文案 打款中5 6 打款成功3 展示固定文案 -->
            <template v-if="[3, 5, 6, 2, 7].includes(info.state)">
              <template v-if="info.withdrawalMethod === 'Paypal'">
                <p class="status-subtitle">{{ $t('lang.instantPayment.paypalPaymentInProgress') }}</p>
              </template>
              <template v-else>
                <p class="status-subtitle">{{ $t('lang.instantPayment.paymentInProgress') }}</p>
              </template>
            </template>
            <!-- 审核驳回和失败展示服务器文案 -->
            <template v-else-if="[1, 4].includes(info.state)">
              <template v-if="info.refuseType == 1">
                <p class="status-subtitle">{{ $t('lang.instantPayment.error1') }}</p>
              </template>
              <template v-else-if="info.refuseType == 2">
                <p class="status-subtitle">{{ $t('lang.instantPayment.error2') }}</p>
              </template>
              <template v-else-if="info.refuseType == 3">
                <p class="status-subtitle">{{ $t('lang.instantPayment.error3') }}</p>
              </template>
              <template v-else-if="info.refuseType == 4">
                <p class="status-subtitle">{{ $t('lang.instantPayment.error4') }}</p>
              </template>
              <template v-else>
                <p class="status-subtitle">{{ $t('lang.instantPayment.error5') }}</p>
              </template>
            </template>
            <template v-else>
              <p class="status-subtitle"></p>
            </template>
          </template>
        </div>
        <!-- 信息 -->
        <div class="info-wrapper">
          <div class="info-item">
            <div class="item-title">{{ $t('lang.instantPayment.method') }}</div>
            <div class="item-value">{{ info.withdrawalMethod || '-' }}</div>
          </div>
          <div class="info-item">
            <div class="item-title">{{ $t('lang.instantPayment.amount') }}</div>
            <div class="item-value purple">{{ info.applyAmount ? `≈${info.currency} ${handleUSDollar(info.applyAmount)}` : '-' }}</div>
          </div>
          <div class="info-item" v-if="info.feeRate">
            <div class="item-title">{{ $t('lang.instantPayment.fee') }}</div>
            <div class="item-value purple">{{ info.feeRate || '-' }}</div>
          </div>
          <div class="info-item">
            <div class="item-title">{{ $t('lang.instantPayment.arrivalAmount') }}</div>
            <div class="item-value purple">{{ info.arrivalAmount || info.arrivalAmount == 0 ? `≈${info.currency} ${handleUSDollar(info.arrivalAmount)}` : '-' }}</div>
          </div>
          <div class="info-item">
            <div class="item-title">{{ $t('lang.wd.phAccount') }}</div>
            <div class="item-value">{{ info.accountId || '-' }}</div>
          </div>
          <div class="info-item">
            <div class="item-title">{{ $t('lang.instantPayment.userId') }}</div>
            <div class="item-value">{{ info.presentId || '-' }}</div>
          </div>
          <div class="info-item">
            <div class="item-title">{{ $t('lang.instantPayment.withdrawalId') }}</div>
            <div class="item-value">{{ info.withdrawId || '-' }}</div>
          </div>
          <div class="info-item">
            <div class="item-title">{{ $t('lang.instantPayment.submissionTime') }}</div>
            <div class="item-value">{{ info.submitTime ? handleMoment(info.submitTime, 'DD/MM/YYYY HH:mm:ss') : '-' }}</div>
          </div>
          <div class="info-item" v-if="[1, 3, 4, 5, 6].includes(info.state) && info.dealWithTime">
            <div class="item-title">{{ $t('lang.instantPayment.reviewTime') }}</div>
            <div class="item-value">{{ info.dealWithTime ? handleMoment(info.dealWithTime, 'DD/MM/YYYY HH:mm:ss') : '-' }}</div>
          </div>
          <div class="info-item" v-if="[3, 5, 6].includes(info.state) && info.paymentTime">
            <div class="item-title">{{ $t('lang.instantPayment.paymentTime') }}</div>
            <div class="item-value">{{ info.paymentTime ? handleMoment(info.paymentTime, 'DD/MM/YYYY HH:mm:ss') : '-' }}</div>
          </div>
        </div>
      </template>
    </div>
    <div style="width: 100%; height: 100px"></div>

    <div v-if="info && info.refuseType == 1" class="change-btn" :style="{ 'margin-bottom': `${bottomBarHeight}px` }" @click="handleToAccountEdit">
      {{ $t('lang.commonM.k082') }}
    </div>
    <WaterMark :text="localTime"></WaterMark>
  </div>
</template>

<script>
import { apiGetWithdrawStatus, apiFetchUserAccountInfo } from '@/api/imee'

import WaterMark from '@/components/WaterMark/index.vue'

export default {
  components: { WaterMark },
  data() {
    const query = this.$route.query
    const localTime = this.handleMoment(Date.now(), 'DD/MM/YYYY HH:mm:ss')
    return {
      barHeight: query.statusBarHeight || 38,
      type: '',
      hasRefresh: false,
      isLoading: false,
      info: {
        state: 0,
        withdrawalMethod: '',
        feeRate: '',
        accountId: '',
        withdrawId: '',
        submitTime: 0,
        // 0 其他,1 信息错误,2 账号违规,3 通话违规,4 信息不完整
        refuseType: 0
      },
      // 0 8 审核中, 1 4 审核驳回, 2 5 6 7打款中, 3 打款成功
      statusTextMap: {
        0: this.$t('lang.instantPayment.reviewing'),
        1: this.$t('lang.wd.state1'),
        2: this.$t('lang.instantPayment.paying'),
        3: this.$t('lang.instantPayment.success'),
        4: this.$t('lang.wd.state1'),
        5: this.$t('lang.instantPayment.paying'),
        6: this.$t('lang.instantPayment.paying'),
        7: this.$t('lang.instantPayment.paying'),
        8: this.$t('lang.instantPayment.reviewing')
      },
      localTime: localTime
    }
  },
  mounted() {
    this.handleGetData()
  },
  computed: {
    // 美分转美元
    handleUSDollar() {
      return (amount) => {
        if (amount === 0) {
          return amount
        } else {
          return (amount / 100).toFixed(2)
        }
      }
    }
  },
  methods: {
    async handleGetData() {
      try {
        const queryParam = this.$route.query || {}
        this.isLoading = true
        this.hasRefresh = false
        const res = await apiGetWithdrawStatus(queryParam.withdrawId || '')
        this.handleGetQueryParam(res)
        this.isLoading = false
        this.hasRefresh = true
      } catch (error) {
        this.isLoading = false
        this.hasRefresh = true
      }
    },
    handleGetQueryParam(dataParam) {
      if (dataParam) {
        this.info = dataParam
        this.info.state = Number(dataParam.state || 0)
        this.info.withdrawalMethod = dataParam.withdrawalMethod || ''
        this.info.feeRate = dataParam.feeRate || ''
        this.info.accountId = dataParam.accountId || ''
        this.info.withdrawId = dataParam.withdrawId || ''
        this.info.submitTime = Number(dataParam.createTime || '0')
        this.info.arrivalAmount = dataParam.arrivalAmount || 0
        this.info.amount = dataParam.amount || 0
        if (this.info.feeRate) {
          this.info.feeRate = `${this.info.feeRate * 100}%`
        }
        this.hasRefresh = true
      } else {
        this.$client.showToast(this.$t('lang.common.errorTips'))
      }
    },
    handleToAccountEdit() {
      apiFetchUserAccountInfo().then((res) => {
        this.$router.push({
          path: 'withdrawal-account',
          query: {
            icon: this.info.withdrawalMethodIcon,
            locaFlag: res.locationFlag,
            locaCode: res.locationCode,
            walletType: this.info.walletType,
            withdrawalMethod: this.info.withdrawalMethod,
            minDollarAmount: null,
            change: true
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.withdrawal-details-ststus-wrapper {
  width: 100%;
  height: 100vh;
  background-color: #eeeef1;
  .custom-nav-block {
    background-color: #eeeef1;
  }
  .main {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
    width: 100%;
    height: calc(100% - 46px);
    color: #666666;
    line-height: 20px;
    .loading-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
    }
    .status-wrapper {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-direction: column;
      flex-shrink: 0;
      width: 100%;
      height: min-content;
      min-height: 166px;
      padding: 30px 16px 0px 16px;
      .status-title {
        width: 100%;
        margin: 10px 0px;
        font-family: RobotoFlex-Regular;
        font-weight: bold;
        font-size: 20px;
        color: #333333;
        line-height: 24px;
        text-align: center;
        font-style: normal;
      }
      .status-subtitle {
        width: 100%;
        margin-bottom: 30px;
        font-family: RobotoFlex-Regular;
        font-weight: 400;
        font-size: 15px;
        color: #333333;
        line-height: 18px;
        text-align: center;
        font-style: normal;
      }
    }
    .info-wrapper {
      flex: auto;
      width: 100%;
      background-color: #fff;
      padding: 37px 16px 20px 16px;
      .info-item {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        width: 100%;
        height: min-content;
        padding-bottom: 24px;
        .item-title {
          width: fit-content;
          flex-grow: 0;
          font-family: RobotoFlex-Regular;
          font-weight: 400;
          font-size: 15px;
          color: #999999;
          line-height: 18px;
          text-align: left;
          font-style: normal;
          padding-right: 10px;
        }
        .item-value {
          flex-grow: 1;
          font-family: RobotoFlex-Regular;
          font-weight: 400;
          font-size: 15px;
          color: #333333;
          line-height: 18px;
          text-align: right;
          font-style: normal;
          word-break: break-word;
        }
        .purple {
          color: #a338fc !important;
        }
      }
    }
  }
  .change-btn {
    width: 289px;
    height: 48px;
    line-height: 48px;
    background: #a338fc;
    border-radius: 24px;
    font-family: RobotoFlex-Regular;
    font-size: 15px;
    color: #ffffff;
    text-align: center;
    position: fixed;
    left: 50%;
    bottom: 40px;
    margin-left: -144px;
  }
}

.withdrawal-details-ststus-wrapper.kiko {
  width: 100%;
  height: 100vh;
  background-color: #eeeef1;
  .custom-nav-block {
    background-color: #eeeef1;
  }
  .main {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
    width: 100%;
    height: calc(100% - 46px);
    color: #666666;
    line-height: 20px;
    .loading-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
    }
    .status-wrapper {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-direction: column;
      flex-shrink: 0;
      width: 100%;
      height: min-content;
      min-height: 166px;
      padding: 30px 16px 0px 16px;
      .status-title {
        width: 100%;
        margin: 10px 0px;
        font-family: RobotoFlex-Regular;
        font-weight: bold;
        font-size: 20px;
        color: #333333;
        line-height: 24px;
        text-align: center;
        font-style: normal;
      }
      .status-subtitle {
        width: 100%;
        margin-bottom: 30px;
        font-family: RobotoFlex-Regular;
        font-weight: 400;
        font-size: 15px;
        color: #333333;
        line-height: 18px;
        text-align: center;
        font-style: normal;
      }
    }
    .info-wrapper {
      flex: auto;
      width: 100%;
      background-color: #fff;
      padding: 37px 16px 20px 16px;
      .info-item {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        width: 100%;
        height: min-content;
        padding-bottom: 24px;
        .item-title {
          width: fit-content;
          flex-grow: 0;
          font-family: RobotoFlex-Regular;
          font-weight: 400;
          font-size: 15px;
          color: #999999;
          line-height: 18px;
          text-align: left;
          font-style: normal;
          padding-right: 10px;
        }
        .item-value {
          flex-grow: 1;
          font-family: RobotoFlex-Regular;
          font-weight: 400;
          font-size: 15px;
          color: #333333;
          line-height: 18px;
          text-align: right;
          font-style: normal;
          word-break: break-word;
        }
        .purple {
          color: #b79b21 !important;
        }
      }
    }
  }
  .change-btn {
    width: 289px;
    height: 48px;
    line-height: 48px;
    background: #ffe242;
    border-radius: 24px;
    font-family: RobotoFlex-Regular;
    font-size: 15px;
    color: #000000;
    text-align: center;
    position: fixed;
    left: 50%;
    bottom: 40px;
    margin-left: -144px;
  }
}

.refresh-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 40px;
  height: 100%;
  .refresh {
    animation: rotate360 1s linear infinite;
  }
}

@keyframes rotate360 {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

// 阿语样式特殊处理
html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .withdrawal-details-ststus-wrapper {
    .main {
      .info-wrapper {
        .info-item {
          .item-value {
            text-align: left;
          }
        }
      }
    }
  }
}
</style>
